import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserkeyword } from 'store/actions/account';
import { makeStyles } from '@mui/styles';

import { StaffListToolbar, StaffTable } from './components';


import CircularProgress from '@mui/material/CircularProgress';



import { getStaffList } from "apis/staffAPIs";
import {
  useQuery,

} from "@tanstack/react-query";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));


const StaffList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // The search filter in the store is shared by all list pages, while the search
  // box starts empty; clear it so a search typed on another page doesn't hide rows.
  useEffect(() => {
    dispatch(updateUserkeyword(""));
  }, [dispatch]);
  
  const query = useQuery({ queryKey: ["staffList"], queryFn: getStaffList });

  if (query.isLoading === true) {
    return (
      <main className={classes.content}>
        {query.isLoading && <CircularProgress size={150} className={classes.uiProgess} />}
      </main>
    );
  } else {

  return (
    <div className={classes.root}>
      <StaffListToolbar/>
      <div className={classes.content}>
        {query && query.data && query.data ? (
        <StaffTable staffList={query.data} />
      ): null}
      </div>
    </div>
  );
  }
};

export default StaffList;
